import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Layout from './components/layout';
import FiresideChats from './pages/firesideChats';
import Video from './pages/firesideChats/video';
import About from './pages/about';
import './assets/css/future-pathways.css';

const contentRoutes = (
  <Route element={<Layout />}>
    <Route index element={<FiresideChats />} />
    <Route path="about" element={<About />} />
  </Route>
);

const videoRoutes = (
  <Route path="video" element={<Layout />}>
    <Route path=":slug" element={<Video />} />
  </Route>
);

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/">
          {contentRoutes}
          {videoRoutes}
        </Route>

        <Route path="fr">
          {contentRoutes}
          {videoRoutes}
        </Route>

        <Route path="fr-ca">
          {contentRoutes}
          {videoRoutes}
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
